import { render, staticRenderFns } from "./RecorderStartPauseButton.vue?vue&type=template&id=4cb92164&scoped=true"
import script from "./RecorderStartPauseButton.vue?vue&type=script&lang=ts"
export * from "./RecorderStartPauseButton.vue?vue&type=script&lang=ts"
import style0 from "./RecorderStartPauseButton.vue?vue&type=style&index=0&id=4cb92164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb92164",
  null
  
)

export default component.exports